/**
 * Swiper 11.2.6
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';

/**
 * Swiper default settings for cards sliders
 */
// Load Swiper with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadSwiper = {
    attach: function (context, settings) {
      const Swipers = context.querySelectorAll('.js-swiper');

      if (Swipers.length) {
        for (const swiper of Swipers) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper.querySelector('.swiper'), {
            modules: [Navigation, Keyboard],
            slidesPerView: 'auto',
            speed: 700,
            navigation: {
              nextEl: swiper.querySelector('.swiper-button-next'),
              prevEl: swiper.querySelector('.swiper-button-prev'),
            },
            keyboard: true,
            init: false,
          });

          // Init only if there is 2 or more slides
          const nbSlides = swiper.querySelectorAll('.swiper-slide');

          if (nbSlides.length > 1) {
            swiperInstance.init();
          }
        }
      }
    },
  };
})(jQuery, Drupal);
